import type { Language } from '@models/i18n/language.model';

export const SESSION_KEYS = {
  LANGUAGE: 'fz_language',
  MASTER_DATA: 'fz_master_data',
  AUTH_TOKEN: 'fz_auth_token',
  WEB_SESSION_ID: 'fz_web_session_id',
  SELECTED_PAX_FOR_CHECK_IN: 'fz_selected_pax_for_check_in',
  ENABLED_SSRS: 'fz_enabled_ssrs',
  INCLUDE_REVIEW_BREADCRUMB: 'fz_include_review_breadcrumb',
  SHOW_LANDING_HEADER_STEPPER: 'fz_show_landing_header_stepper',
} as const;

/** Returns a per-language master-data session key, e.g. `fz_md_en`. */
export const getMasterDataKey = (language: Language): string => `fz_md_${language}`;

/** Returns a per-key APP_SETTINGS cache key, e.g. `fz_app_setting_gtmId`. */
export const getAppSettingKey = (key: string): string => `fz_app_setting_${key}`;

export type SessionKey = (typeof SESSION_KEYS)[keyof typeof SESSION_KEYS];
